import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  FormGroup,
  CustomInput,
  Button,
  ButtonGroup,
  Form,
  Modal,
  ModalBody,
  InputGroup,
  Label
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';

import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';

import {
  gAPI_Property_List_By_Group,
  gAPI_Ingetration,
  gAPI_WechatIntegration,
  postAPI_Create_WechatIngetration_Group,
  gAPI_WechatIngetration_Group,
  gAPI_Account_WechatIngetrationBy_Property_Group,
} from '../../../../../constants/APIs';
import short from 'short-uuid';
import Axios from 'axios';
import Validation from '../../../../../components/Validation';
let arr = [];
export default function WechatIntegration({ visible, toggle, id }) {
  const [property, setProperty] = useState([]);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [inputData, setInputData] = useState({
    GroupId: getGroupID(),
    Name: '',
    propertyId: '',
    SessionTimeoutInSeconds: 600,
    DefaultLanguage: 'en-US',
    AppId: '',
    AppSecret: '',
    EncodingAESKey: '',
    Account: '',
  });

  useEffect(() => {
    if (id !== undefined) {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_WechatIntegration}/${id}?group_id=${getGroupID()}`,
      })
        .then((res) => {
          // console.log(res.data)
          setInputData({
            ...inputData,
            Name: res.data.name,
            propertyId: res.data.properties[0],
            AppId: res.data.channelDetails.appId,
            AppSecret: res.data.channelDetails.appSecret,
            EncodingAESKey: res.data.channelDetails.encodingAESKey,
            Account: res.data.channelDetails.account,
          });
        })
        .catch((err) => console.log('err', err));

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
    } else {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
    }
  }, [id]);

  const handleNameChange = (e) => {
    e.persist();
    setInputData({ ...inputData, Name: e.target.value });
  };

  const handleAppIdChange = (e) => {
    e.persist();
    setInputData({ ...inputData, AppId: e.target.value });
    //console.log(inputData)
  };

  const handleAppSecretChange = (e) => {
    e.persist();
    setInputData({ ...inputData, AppSecret: e.target.value });
    //console.log(inputData)
  };
  const handleEncodingAESKeyChange = (e) => {
    e.persist();
    setInputData({ ...inputData, EncodingAESKey: e.target.value });
    //console.log(inputData)
  };
  const handleAccountChange = (e) => {
    e.persist();
    setInputData({ ...inputData, Account: e.target.value });
    // console.log(inputData)
  };

  const handleCheckChange = (e) => {
    if (e.target.checked) {
      setInputData({ ...inputData, propertyId: e.target.value });
    }
    if (!e.target.checked) {
      setInputData({ ...inputData, propertyId: '' });
    }
  };

  const handleSave = async () => {
    if (id !== undefined) {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_WechatIngetration_Group}?account_id=${inputData.Account}`,
      }).then((res) => {
        //console.log(res.data);
        //console.log(res.data.Id);
        let forceRefresh = {
          updater: 'Dashboard',
          refresh: true,
          accountId: inputData.Account,
        };
        AxiosAPI({
          method: 'put',
          url: `${gAPI_WechatIntegration}/${id}?group_id=${getGroupID()}`,
          data: inputData,
        }).then(() =>
          AxiosAPI({
            method: 'put',
            url: `${gAPI_WechatIngetration_Group}/${res.data.Id}`,
            data: forceRefresh,
          }).then((res) => {
            if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
              && res.data.Messages !== null && res.data.Messages.length > 0) {
              setMsg(res.data.Messages);
              setOpen(true);
            }
            else {
              toggle();
              setTimeout(() => {
                //window.location.reload();
              }, 300);
            }
          })
        );
      });
    } else {
      let groupWechatRequest = {
        groupId: getGroupID(),
        propertyId: inputData.propertyId,
        accountId: inputData.Account,
        creator: 'Dashboard',
      };
      AxiosAPI({
        method: 'post',
        url: gAPI_WechatIntegration,
        data: inputData,
      }).then((res) => {
        if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
          && res.data.Messages !== null && res.data.Messages.length > 0) {
          setMsg(res.data.Messages);
          setOpen(true);
        }
        else {
          toggle();
          groupWechatRequest.integrationId = res.data.id;

          AxiosAPI({
            method: 'post',
            url: `${postAPI_Create_WechatIngetration_Group}`,
            data: groupWechatRequest,
          }).then(() =>
            setTimeout(() => {
              // window.location.reload();
            }, 300)
          );
        }
      });
    }
  };
  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle}>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <div className="text-center">
                <h6>{id === undefined ? "Add" : "Update"} WeChat Integration</h6>
                <Separator className="mb-3" />
                <Form>
                  <FormGroup className="mb-2 text-left">
                    <Label>Integration Name</Label>
                    <Input
                      type="text"
                      name="integrationName"
                      onChange={handleNameChange}
                      placeholder="Integration Name"
                      defaultValue={inputData.Name}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2 text-left">
                    <Label>App Id</Label>
                    <Input
                      type="text"
                      name="appid"
                      onChange={handleAppIdChange}
                      placeholder="App Id"
                      defaultValue={inputData.AppId}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2 text-left">
                    <Label>App Secret</Label>
                    <Input
                      type="text"
                      name="appsecret"
                      onChange={handleAppSecretChange}
                      placeholder="App Secret"
                      defaultValue={inputData.AppSecret}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2 text-left">
                    <Label>Encoding AES Key</Label>
                    <Input
                      type="text"
                      name="encodingAESKey"
                      onChange={handleEncodingAESKeyChange}
                      placeholder="Encoding AES Key"
                      defaultValue={inputData.EncodingAESKey}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2 text-left">
                    <Label>Account</Label>
                    <Input
                      type="text"
                      name="account"
                      onChange={handleAccountChange}
                      placeholder="Account"
                      defaultValue={inputData.Account}
                    />
                  </FormGroup>
                  <FormGroup>
                    <div className='integration-property'>
                      {property.map((p, index) => {
                        return (
                          <CustomInput
                            key={p.id}
                            type="radio"
                            id={index}
                            label={p.name}
                            value={p.id}
                            name="property"
                            checked={
                              p.id === inputData.propertyId ? true : false
                            }
                            onChange={handleCheckChange}
                          />
                        );
                      })}
                    </div>
                  </FormGroup>
                </Form>
                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                  {id === undefined ? (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Create New Integration
                    </Button>
                  ) : (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Update Integration
                    </Button>
                  )}

                  <Button size="xs" color="dark" outline onClick={toggle}>
                    Cancel
                  </Button>
                </ButtonGroup>
              </div>
            </Colxx>
          </Row>
        </ModalBody>
      </Modal>
      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
    </Fragment>
  );
}
